import { InMemoryCache } from "@apollo/client";

export const cache = new InMemoryCache({
    typePolicies: {
        AudienceCategory: {
            keyFields: ["id", "targetAudiencePercent", "dimensionName"],
        },
    },
});
